import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { cloneDeep } from 'lodash';
import { IQueue } from '~/utils/interface/common';

export interface CommonState {
  queueList: Array<IQueue>;
  isLoading: boolean;
}

const initialState: CommonState = {
  queueList: [],
  isLoading: false,
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setQueue(state, action: PayloadAction<IQueue>) {
      let queueList = cloneDeep(state.queueList);
      const existQueueIndex = queueList.findIndex((queue) => queue.id === action.payload.id);
      if (existQueueIndex === -1) {
        queueList = [{ ...action.payload }, ...queueList];
      } else {
        queueList.splice(existQueueIndex, 1, { ...queueList[existQueueIndex], ...action.payload });
      }
      state.queueList = queueList;
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
  },
});

export const commonActions = commonSlice.actions;

const commonReducer = commonSlice.reducer;

export default commonReducer;
